import { useEffect } from 'react'
import type {
  AdvancedMentoringProductDTO,
  BasicMentoringProductDTO
} from '@/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto'
import type { Subscription } from '@/common/enums'

type UseUpdateMentoringProductOnTabChangeProps<
  T extends AdvancedMentoringProductDTO | BasicMentoringProductDTO
> = {
  mentoringProduct: T
  subscription: Subscription
  setMentoringProduct: React.Dispatch<React.SetStateAction<T>>
}

export function useUpdateMentoringProductOnTabChange<
  T extends AdvancedMentoringProductDTO | BasicMentoringProductDTO
>({
  mentoringProduct: _mentoringProduct,
  subscription,
  setMentoringProduct
}: UseUpdateMentoringProductOnTabChangeProps<T>) {
  useEffect(() => {
    setMentoringProduct(prev => ({
      ...prev,
      subscription: subscription
    }))
  }, [subscription, setMentoringProduct])
}
